import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ImpSpinner from '../ImpSpinner/ImpSpinner';
const Input = styled.input `
  opacity: 0;
  position: absolute;
`;
const Track = styled.div `
  position: relative;
  width: 52px;
  height: 32px;
  background: #faf9f9;
  border-radius: 60px;
  padding: 2px;
  transition: 300ms all;
  cursor: pointer;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 28px;
    height: 28px;
    border-radius: 35px;
    top: 50%;
    left: 4px;
    background: white;
    transform: translate(0, -50%);
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.12);
  }
`;
const Container = styled.div `
width: fit-content;
  ${Input}:checked + ${Track} {
    background: var(--merchant-color);
  }

  ${Input}:checked + ${Track}::before {
    transform: translate(20px, -50%);
  }

  ${({ isDisabled }) => isDisabled &&
    `
    cursor: not-allowed;
    ${Input}, ${Track} {
      pointer-events: none;
    }

    ${Track} {
      opacity: 50%;
    }
  `}
`;
export default function ImpToggle({ isLoading = false, isDisabled = false, checked, onChange, }) {
    const [isChecked, setIsChecked] = useState(checked || false);
    const inputRef = useRef(null);
    useEffect(() => {
        setIsChecked(checked || false);
    }, [checked]);
    const handleChange = () => {
        let newVal = !isChecked;
        setIsChecked(newVal);
        onChange && onChange(newVal);
    };
    return (React.createElement(Container, { isDisabled: isDisabled, "data-testid": "toggle-container" }, isLoading ? (React.createElement(ImpSpinner, { size: 'l' })) : (React.createElement(React.Fragment, null,
        React.createElement(Input, { ref: inputRef, checked: isChecked, type: "checkbox", onChange: handleChange, id: "toggle", "data-testid": "toggle-input" }),
        React.createElement(Track, { "data-testid": "toggle-track" })))));
}
//# sourceMappingURL=ImpToggle.js.map